var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableButtonDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33301 3.00016C1.33301 2.07969 2.0792 1.3335 2.99967 1.3335H12.9997C13.9201 1.3335 14.6663 2.07969 14.6663 3.00016V13.0002C14.6663 13.9206 13.9201 14.6668 12.9997 14.6668H2.99967C2.0792 14.6668 1.33301 13.9206 1.33301 13.0002V3.00016ZM13.833 4.66683H10.4997V7.16683H13.833V4.66683ZM13.833 8.00016H10.4997V10.5002H13.833V8.00016ZM13.833 11.3335H10.4997V13.8335H12.9997C13.4599 13.8335 13.833 13.4604 13.833 13.0002V11.3335ZM9.66634 13.8335V11.3335H6.33301V13.8335H9.66634ZM5.49967 13.8335V11.3335H2.16634V13.0002C2.16634 13.4604 2.53944 13.8335 2.99967 13.8335H5.49967ZM2.16634 10.5002H5.49967V8.00016H2.16634V10.5002ZM2.16634 7.16683H5.49967V4.66683H2.16634V7.16683ZM6.33301 4.66683V7.16683H9.66634V4.66683H6.33301ZM9.66634 8.00016H6.33301V10.5002H9.66634V8.00016Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableButtonDropdown);
export default __webpack_public_path__ + "static/media/tableButtonDropdown.2dc2096ac1d7591194321ef3fd7204db.svg";
export { ForwardRef as ReactComponent };